<!-- 废弃 -->
<template>
	<div>
		<myheader :backFlag="true" headTitle="认证方式"></myheader>
		<div class="header_extend_main">
			<div class="header_extend_back"></div>
			<div class="header_extend_content">
				<div class="all_tips_content_card">
					<div style="width: 100%; text-align: center;padding:1rem 0;">
						<img style="width:4rem;height:4rem;margin: 0.2rem" @click="showBottom=true">
						<div class="text12 textcolor999 margin_top_2">认证完成</div>
						<div class="text14 textcolor666 margin_top_2">您已完成个人认证</div>
					</div>
				</div>
			</div>
			<div class="all_tips_bottom_card">
				<button class="all_button24 width_100 text16">完&nbsp;&nbsp;成</button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		methods: {
			// onComplete(){
			// 	this.$router.go(-1)
			// },
		},
	}
</script>

<style scoped lang="scss">
	@import "../../../styles/global.css";
</style>